/**
 * New Relic Browser Agent Configuration
 * This file configures New Relic based on runtime hostname detection
 * Supports localhost (no tracking), dev, and production environments
 */

(function () {
    'use strict';

    // Determine environment based on hostname
    var hostname = window.location.hostname;
    var isProd = hostname === 'craig.parts.accuristech.com';
    var isDev = hostname === 'craig.dev.parts.accuristech.com';
    var isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

    // Only configure New Relic for non-localhost environments
    if (!isLocalhost) {
        // Environment-specific configurations
        var configs = {
            development: {
                agentID: '1431869312',
                applicationID: '1431869312',
                sessionReplayEnabled: false
            },
            production: {
                agentID: '1431869314',
                applicationID: '1431869314',
                accountID: '6470797',
                sessionReplayEnabled: true
            }
        };

        var currentEnv = isProd ? 'production' : 'development';
        var config = configs[currentEnv];

        // Base configuration shared across all environments
        var baseInitConfig = {
            distributed_tracing: { enabled: true },
            performance: { capture_measures: true },
            privacy: { cookies_enabled: true },
            ajax: { deny_list: ['bam.nr-data.net'] },
            // Disable SPA features that patch Promise/async to avoid Zone.js conflicts
            spa: { enabled: false },
            page_action: { enabled: true },
            session_trace: { enabled: true },
            // Disable soft navigations as it may patch browser APIs
            soft_navigations: { enabled: false }
        };

        var baseLoaderConfig = {
            trustKey: '3966643',
            licenseKey: 'NRJS-c78a69341edda6e360d'
        };

        var baseInfo = {
            beacon: 'bam.nr-data.net',
            errorBeacon: 'bam.nr-data.net',
            licenseKey: 'NRJS-c78a69341edda6e360d',
            sa: 1
        };

        // Apply configuration
        window.NREUM = window.NREUM || {};

        // Build init config with environment-specific session replay settings
        window.NREUM.init = Object.assign({}, baseInitConfig, {
            session_replay: {
                enabled: config.sessionReplayEnabled,
                autoStart: false,
                mask_all_inputs: true,
                mask_text_selector: '*'
            }
        });

        // Build loader config with environment-specific IDs
        window.NREUM.loader_config = Object.assign({}, baseLoaderConfig, {
            agentID: config.agentID,
            applicationID: config.applicationID
        });

        // Add accountID for production
        if (config.accountID) {
            window.NREUM.loader_config.accountID = config.accountID;
        }

        // Build info config
        window.NREUM.info = Object.assign({}, baseInfo, {
            applicationID: config.applicationID
        });

        // Load the New Relic Browser Agent only for non-localhost environments
        (function () {
            // Using standard SPA loader with conflicting features disabled in config
            var js = 'https://js-agent.newrelic.com/nr-loader-spa-current.min.js';
            var d = document;
            var t = d.getElementsByTagName('script')[0];
            var s = d.createElement('script');
            s.src = js;
            // Load synchronously to ensure it's ready before Angular
            s.async = false;
            s.defer = false;
            if (t && t.parentNode) {
                t.parentNode.insertBefore(s, t);
            }
        })();

        console.log('New Relic configured for environment:', currentEnv);
    } else {
        console.log('New Relic skipped for localhost development');
    }
})();
